module.exports = __webpack_public_path__ + "img/Slide5.0f8aafbd.png";